module.exports = __webpack_public_path__ + "static/5-06285e7bed80870dbd8c1b11bf60ea43.svg";